// src/App.js
import React from "react";
// import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
// import Home from "./pages/home/Home";
import Router from "./Router/Router";
// import About from "./pages/About";
// import Contact from "./pages/Contact";

function App() {
  return <Router />;
}

export default App;
